import { render, staticRenderFns } from "./suggestionsListKeywordsAdder.vue.html?vue&type=template&id=6a3910b4&"
import script from "./suggestionsListKeywordsAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListKeywordsAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports